import LOCALS from 'commons/locals';
import i18n from 'i18n';
import { Button } from 'antd';

export const getVisibleImageItems = (
  items: string[] | undefined,
  expanded: boolean,
) => {
  if (!items?.length) return [];
  return expanded ? items : items.slice(0, 1);
};

export const ImageListToolbar = ({
  count,
  expanded,
  onToggle,
}: {
  count: number;
  expanded: boolean;
  onToggle: () => void;
}) => {
  if (count <= 0) return null;

  return (
    <div className="flex items-center gap-2 mb-2">
      <span className="text-gray-500">
        {i18n.t(LOCALS.product_image_count, { count })}
      </span>
      {count > 1 && (
        <Button size="small" htmlType="button" onClick={onToggle}>
          {expanded ? i18n.t(LOCALS.collapse) : i18n.t(LOCALS.show_all)}
        </Button>
      )}
    </div>
  );
};
